import { render, staticRenderFns } from "./StatisticsDetail.vue?vue&type=template&id=00c71804&"
import script from "./StatisticsDetail.vue?vue&type=script&lang=ts&"
export * from "./StatisticsDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports